import { ThemeProvider, createTheme } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import { DialogProvider } from './components/contextProviders/DialogContext';
import AudiometryForm from './pages/audiometry-form/AudiometryForm';
import AuditAdmissionForm from './pages/audit-admission-form/AuditAdmissionForm';
import AuditAdmissionList from './pages/audit-admission-list/AuditAdmissionList';
import AuditAdmission from './pages/audit-admission/AuditAdmission';
import AuditManagement from './pages/audit-management/AuditManagement';
import ComparationAudits from './pages/comparation-audits/ComparationAudits';
import ComparationEvents from './pages/comparation-events/ComparationEvents';
import Comparations from './pages/comparations/Comparations';
import ComplaintEnd from './pages/complaint-end/ComplaintEnd';
import ComplaintFollowUp from './pages/complaint-followup/ComplaintFollowUp';
import ComplaintForm from './pages/complaint-form/ComplaintForm';
import ComplaintManagement from './pages/complaint-management/ComplaintManagement';
import ComplaintPanel from './pages/complaint-panel/ComplaintPanel';
import Complaint from './pages/complaint/Complaint';
import Configurations from './pages/configurations/Configurations';
import DeliveryDocuments from './pages/delivery-documents/DeliveryDocuments';
import Docs from './pages/documentation/Docs';
import Documents from './pages/documents/Documents';
import Employees from './pages/employees/Employees';
import EpiCompliance from './pages/epi-compliance/EpiCompliance';
import EpiDashboard from './pages/epi-dashboard/EpiDashboard';
import EpiInspectionPanel from './pages/epi-inspection-panel/EpiInspectionPanel';
import EpiInspectionConfig from './pages/epi-inspection-config/EpiInspectionConfig';
import EpiInspectionDetail from './pages/epi-inspection-detail/EpiInspectionDetail';
import EpiInspectionDossier from './pages/epi-inspection-dossier/EpiInspectionDossier';
import EpiInspectionList from './pages/epi-inspection-list/EpiInspectionList';
import EpiInspectionNew from './pages/epi-inspection-new/EpiInspectionNew';
import EpiInspectionWizard from './pages/epi-inspection-wizard/EpiInspectionWizard';
import EpiNonConformity from './pages/epi-nonconformity/EpiNonConformity';
import ExecutionEvents from './pages/execution-events/ExecutionEvents';
import Executions from './pages/executions/Executions';
import Forms from './pages/forms/Forms';
import HomeComponent from './pages/home/Home';
import Login from './pages/login/Login';
import PrivacyPolicy from './pages/policy/PrivacyPolicy';
import RiskAssessmentChanges from './pages/risk-assessment-changes/RiskAssessmentChanges';
import RiskAssessmentHistory from './pages/risk-assessment-history/RiskAssessmentHistory';
import RiskAssessmentLinks from './pages/risk-assessment-links/RiskAssessmentLinks';
import RiskAssessmentNew from './pages/risk-assessment-new/RiskAssessmentNew';
import RiskAssessmentPanel from './pages/risk-assessment-panel/RiskAssessmentPanel';
import AuditLGPD from './pages/audit-lgpd/AuditLGPD';

function App() {
	const darkTheme = createTheme({
		palette: {
			mode: 'dark',
		},
	});

	return (
		<ThemeProvider theme={darkTheme}>
			<DialogProvider>
				<Routes>
					<Route path="/login" element={ <Login/>}/>
					<Route path="/inicio" element={<HomeComponent/>}/>
					<Route path="/execucoes" element={<Executions/>}/>
					<Route path="/execucoes-eventos" element={<ExecutionEvents/>}/>
					<Route path="/configuracoes" element={<Configurations/>}/>
					<Route path="/documentacoes" element={<Docs/>}/>
					<Route path="/envio-de-documentos" element={<Documents/>}/>
					<Route path="/formularios" element={<Forms/>}/>
					<Route path="/cadastro-funcionarios" element={<Employees/>}/>
					<Route path="/execucoes/:id/comparacoes" element={<Comparations/>}/>
					<Route path="/execucoes/:id/comparacoes/auditoria" element={<ComparationAudits/>}/>
					<Route path="/execucoes-eventos/:id/comparacoes" element={<ComparationEvents/>}/>
					<Route path="/envio-de-documentos/:id/envios" element={<DeliveryDocuments/>}/>
					<Route path="/gestao-de-denuncias" element={<ComplaintManagement/>}/>
					<Route path="/gestao-de-denuncias/painel" element={<ComplaintPanel/>}/>
					<Route path="/gestao-de-denuncias/painel/:id" element={<Complaint/>}/>
					<Route path="/canal-de-denuncias/:id" element={<ComplaintForm/>}/>
					<Route path="/canal-de-denuncias/:id/protocolo/:protocol" element={<ComplaintEnd />} />
					<Route path="/canal-de-denuncias/:id/acompanhamento/:protocol" element={<ComplaintFollowUp />} />
					<Route path="/canal-de-denuncias/:id/acompanhamento/*" element={<ComplaintFollowUp />} />
					<Route path="/auditoria" element={<AuditManagement />} />
					<Route path="/auditoria/:id/admissoes" element={<AuditAdmissionList />} />
					<Route path="/auditoria/:id/lgpd" element={<AuditLGPD />} />
					<Route path="/auditoria/:groupid/admissoes/:id" element={<AuditAdmission />} />
					<Route path="/auditoria/nova-admissao/:id" element={<AuditAdmissionForm />} />
					<Route path="/audiometria/novo-cadastro" element={<AudiometryForm />} />
					<Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
					<Route path="/inspecao-epis" element={<EpiInspectionPanel/>}/>
					<Route path="/inspecao-epis/configuracoes" element={<EpiInspectionConfig/>}/>
					<Route path="/inspecao-epis/detalhes/:companyId/:type" element={<EpiInspectionDetail/>}/>
					<Route path="/inspecao-epis/nova" element={<EpiInspectionNew/>}/>
					<Route path="/inspecao-epis/nova/:inspectionId" element={<EpiInspectionWizard/>}/>
					<Route path="/inspecao-epis/conformidade" element={<EpiCompliance/>}/>
					<Route path="/inspecao-epis/inspecoes" element={<EpiInspectionList/>}/>
					<Route path="/inspecao-epis/inspecoes/:inspectionId" element={<EpiInspectionDossier/>}/>
					<Route path="/inspecao-epis/nao-conformidades" element={<EpiNonConformity/>}/>
					<Route path="/inspecao-epis/dashboard" element={<EpiDashboard/>}/>
					<Route path="/avaliacao-riscos" element={<RiskAssessmentHistory/>}/>
					<Route path="/avaliacao-riscos/nova" element={<RiskAssessmentNew/>}/>
					<Route path="/avaliacao-riscos/nova/:draftId" element={<RiskAssessmentNew/>}/>
					<Route path="/avaliacao-riscos/historico/:historyId" element={<RiskAssessmentChanges/>}/>
					<Route path="/avaliacao-riscos/painel" element={<RiskAssessmentPanel/>}/>
					<Route path="/avaliacao-riscos/vinculos" element={<RiskAssessmentLinks/>}/>
					<Route path="*" element={<Navigate to="/inicio" replace />}/>
				</Routes>
			</DialogProvider>
		</ThemeProvider>
	);
}

export default App;